module.exports = __webpack_public_path__ + "static/media/dasbierlemohrenpfiff.a7d02abf.png";